import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
/** System post for "battle started": player avatars, names, and W/L/D stats. */
export default class ArenaBattleStartPost extends Component {
  challengerUser = null;
  opponentUser = null;
  loaded = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.resolveUsers();
  }
  async resolveUsers() {
    const content = this.attrs.post.content();
    if (!content) return;
    const fromStore = id => app.store.getById('users', String(id)) ?? null;
    this.challengerUser = fromStore(content.challengerId);
    this.opponentUser = fromStore(content.opponentId);
    if (!this.challengerUser || !this.opponentUser) {
      try {
        const loads = [];
        if (!this.challengerUser) loads.push(app.store.find('users', content.challengerId).catch(() => null));
        if (!this.opponentUser) loads.push(app.store.find('users', content.opponentId).catch(() => null));
        await Promise.all(loads);
        this.challengerUser = fromStore(content.challengerId);
        this.opponentUser = fromStore(content.opponentId);
      } catch {/* ignore */}
    }
    this.loaded = true;
    m.redraw();
  }
  playerColumn(user, fallbackName) {
    const name = user?.displayName() || fallbackName;
    const stats = user?.attribute('arenaStats') ?? null;
    const profileUrl = user ? app.route('user', {
      username: user.username()
    }) : null;
    const nameEl = profileUrl ? m("a", {
      className: "ArenaBattleStartPost-playerName",
      href: profileUrl,
      onclick: e => {
        e.preventDefault();
        m.route.set(profileUrl);
      }
    }, name) : m("div", {
      className: "ArenaBattleStartPost-playerName"
    }, name);
    return m("div", {
      className: "ArenaBattleStartPost-player"
    }, m("div", {
      className: "ArenaBattleStartPost-avatar"
    }, user ? m(Avatar, {
      user: user
    }) : m("span", {
      className: "Avatar ArenaBattleStartPost-avatarFallback"
    }, (name[0] ?? '?').toUpperCase())), nameEl, stats && m("div", {
      className: "ArenaBattleStartPost-playerStats"
    }, m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--wins",
      title: app.translator.trans('forumaker-arena.lib.stats.wins')
    }, m("i", {
      className: "fas fa-trophy"
    }), " ", stats.wins ?? 0), m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--losses",
      title: app.translator.trans('forumaker-arena.lib.stats.losses')
    }, m("i", {
      className: "fas fa-skull"
    }), " ", stats.losses ?? 0), m("span", {
      className: "ArenaBattleStartPost-stat ArenaBattleStartPost-stat--draws",
      title: app.translator.trans('forumaker-arena.lib.stats.draws')
    }, m("i", {
      className: "fas fa-handshake"
    }), " ", stats.draws ?? 0)));
  }
  view() {
    const content = this.attrs.post.content();
    if (!content) return null;
    const fallback = id => app.translator.trans('forumaker-arena.forum.battle.player_fallback', {
      id: String(id)
    });
    const challengerName = this.challengerUser?.displayName() || content.challengerName || fallback(content.challengerId);

    // Only shown for a non-default modifier — 'classic' (or an older post
    // saved before this field existed, i.e. content.modifier missing) means
    // the normal rules apply, which isn't worth calling out.
    const modifier = content.modifier;
    const showModifierLine = !!modifier && modifier !== 'classic';
    return m("div", {
      className: "ArenaBattleStartPost EventPost"
    }, m("div", {
      className: "ArenaBattleStartPost-wrap"
    }, m("div", {
      className: "ArenaBattleStartPost-versus"
    }, this.playerColumn(this.challengerUser, content.challengerName || fallback(content.challengerId)), m("span", {
      className: "ArenaBattleStartPost-vs"
    }, "VS"), this.playerColumn(this.opponentUser, content.opponentName || fallback(content.opponentId)))), m("div", {
      className: "ArenaStartPost"
    }, m("div", {
      className: "ArenaStartPost-icon"
    }, m("i", {
      className: app.forum.attribute('arenaButtonsBattleIcon') || 'fas fa-dungeon'
    })), m("div", {
      className: "ArenaStartPost-body"
    }, m("div", {
      className: "ArenaStartPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_start.first_turn', {
      name: m("strong", null, challengerName)
    })), m("div", {
      className: "ArenaStartPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_start.first_turn_subtitle')), showModifierLine && m("div", {
      className: "ArenaStartPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_start.modifier_active', {
      modifier: app.translator.trans(`forumaker-arena.lib.modifiers.${modifier}`)
    })))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleStartPost', ArenaBattleStartPost);